import EmblaCarousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names'

function initGames() {
    const gamesContainerEl = document.getElementById('gamesSwiper');
    const categoryButtons = document.querySelectorAll('.games__category-btn');
    
    if (!gamesContainerEl) {
        return;
    }
    
    const cardsWrapper = gamesContainerEl.closest('.games__cards-wrapper');
    const viewport = gamesContainerEl.querySelector('.games__cards-viewport');
    const container = gamesContainerEl.querySelector('.games__cards-container');
    const prevBtn = cardsWrapper ? cardsWrapper.querySelector('.games__nav-btn--prev') : null;
    const nextBtn = cardsWrapper ? cardsWrapper.querySelector('.games__nav-btn--next') : null;
    
    if (!viewport || !container) {
        return;
    }
    
    const allCards = Array.from(container.querySelectorAll('.games__card'));
    const cardsData = allCards.map(card => ({
        html: card.outerHTML,
        categories: card.getAttribute('data-categories') || ''
    }));
    
    const updateSingleSlideStyles = () => {
        if (!embla) return;
        
        const engine = embla.internalEngine();
        const loop = engine.options.loop;
        const slideCount = container.children.length;
        const isSingleSlide = slideCount === 1;
        const windowWidth = window.innerWidth;
        const isMobile = windowWidth <= 1100;
        
        if (!loop) {
            if (isMobile && slideCount === 2) {
                container.style.justifyContent = '';
            } else {
                container.style.justifyContent = 'center';
            }
            
            if (isSingleSlide) {
                const cards = container.querySelectorAll('.games__card');
                cards.forEach(card => {
                    card.style.margin = '0 auto';
                    card.style.marginLeft = '0';
                    card.style.marginRight = '0';
                });
            } else {
                const cards = container.querySelectorAll('.games__card');
                cards.forEach(card => {
                    card.style.margin = '';
                    card.style.marginLeft = '';
                    card.style.marginRight = '';
                });
            }
        } else {
            container.style.justifyContent = '';
            const cards = container.querySelectorAll('.games__card');
            cards.forEach(card => {
                card.style.margin = '';
                card.style.marginLeft = '';
                card.style.marginRight = '';
            });
        }
    };
    
    const updateSnappedClasses = () => {
        if (!embla) return;
        
        const windowWidth = window.innerWidth;
        const isDesktop = windowWidth > 1100;
        const slides = embla.slideNodes();
        const currentIndex = embla.selectedScrollSnap();
        const slideCount = slides.length;
        
        if (!isDesktop) {
            slides.forEach((slide, index) => {
                if (index !== currentIndex) {
                    slide.classList.remove('is-snapped');
                }
            });
        } else {
            if (slideCount <= 1) {
                return;
            }
            
            const engine = embla.internalEngine();
            const loop = engine.options.loop;
            
            if (!loop) {
                slides.forEach(slide => {
                    slide.classList.add('is-snapped');
                });
                return;
            }
            
            if (slideCount <= 3) {
                slides.forEach(slide => {
                    slide.classList.add('is-snapped');
                });
                return;
            }
            
            let prevIndex = currentIndex - 1;
            let nextIndex = currentIndex + 1;
            
            if (prevIndex < 0) prevIndex = slideCount - 1;
            if (nextIndex >= slideCount) nextIndex = 0;
            
            const snappedIndexes = [currentIndex, prevIndex, nextIndex];
            
            slides.forEach((slide, index) => {
                if (snappedIndexes.includes(index)) {
                    slide.classList.add('is-snapped');
                } else {
                    slide.classList.remove('is-snapped');
                }
            });
        }
    };
    
    const updateButtons = () => {
        if (!embla || !prevBtn || !nextBtn) return;
        
        const canScrollPrev = embla.canScrollPrev();
        const canScrollNext = embla.canScrollNext();
        
        prevBtn.disabled = !canScrollPrev;
        nextBtn.disabled = !canScrollNext;
        
        prevBtn.classList.toggle('games__nav-btn--disabled', !canScrollPrev);
        nextBtn.classList.toggle('games__nav-btn--disabled', !canScrollNext);
    };
    
    const createEmbla = () => {
        const slideCount = container.children.length;
        const options = {
            align: 'center',
            loop: slideCount >= 3,
            watchDrag: false,
            breakpoints: {
               '(max-width: 1100px)': {
                    watchDrag: true,
                }
            }
        };
        
        const emblaInstance = EmblaCarousel(viewport, options, [ClassNames()]);
        
        const forceLoadVisibleImages = () => {
            if (window.lazySizes && window.lazySizes.loader && container) {
                const lazyElements = container.querySelectorAll('[data-bg]:not(.lazy-loaded)');
                lazyElements.forEach(el => {
                    if (!el.classList.contains('lazy')) {
                        el.classList.add('lazy');
                    }
                    if (!el.classList.contains('lazyload')) {
                        el.classList.add('lazyload');
                    }
                    const dataBg = el.getAttribute('data-bg');
                    if (dataBg && !el.classList.contains('lazy-loaded')) {
                        if (window.lazySizes.loader.unveil) {
                            window.lazySizes.loader.unveil(el);
                        }
                    }
                });
                window.lazySizes.loader.checkElems();
            }
        };
        
        emblaInstance.on('select', () => {
            updateButtons();
            updateSnappedClasses();
            setTimeout(forceLoadVisibleImages, 50);
            setTimeout(forceLoadVisibleImages, 200);
        });
        
        emblaInstance.on('settle', () => {
            setTimeout(forceLoadVisibleImages, 50);
        });
        
        emblaInstance.on('scroll', () => {
            forceLoadVisibleImages();
        });
        
        setTimeout(() => {
            updateSnappedClasses();
        }, 0);
        
        return emblaInstance;
    };
    
    const reInitEmbla = () => {
        if (!embla) return;
        
        const currentIndex = embla.selectedScrollSnap();
        embla.destroy();
        
        setTimeout(() => {
            embla = createEmbla();
            embla.scrollTo(currentIndex);
            updateSingleSlideStyles();
            updateButtons();
            updateSnappedClasses();
            
            if (window.lazySizes && window.lazySizes.loader) {
                const lazyElements = container.querySelectorAll('.lazy[data-bg]:not(.lazy-loaded)');
                lazyElements.forEach(el => {
                    if (window.lazySizes.loader.unveil) {
                        window.lazySizes.loader.unveil(el);
                    }
                });
                window.lazySizes.loader.checkElems();
            }
        }, 50);
    };
    
    let filterTimeout;
    let initTimeout;
    
    const filterAndInit = (category) => {
        if (filterTimeout) {
            clearTimeout(filterTimeout);
        }
        if (initTimeout) {
            clearTimeout(initTimeout);
        }
        
        if (embla) {
            embla.destroy();
            embla = null;
        }
        
        viewport.style.opacity = '0';
        viewport.style.transition = 'opacity 0.3s ease';
        
        filterTimeout = setTimeout(() => {
            container.innerHTML = '';
            
            const filteredCards = cardsData.filter(cardData => {
                if (category === 'all') {
                    return true;
                }
                const cardCategories = cardData.categories;
                if (!cardCategories || cardCategories.trim() === '') {
                    return false;
                }
                const categoriesArray = cardCategories.split(',').map(cat => cat.trim()).filter(cat => cat !== '');
                return categoriesArray.includes(category);
            });
            
            filteredCards.forEach(cardData => {
                container.insertAdjacentHTML('beforeend', cardData.html);
            });
            
            initTimeout = setTimeout(() => {
                if (!embla) {
                    container.style.justifyContent = '';
                    const cards = container.querySelectorAll('.games__card');
                    cards.forEach(card => {
                        card.style.margin = '';
                        card.style.marginLeft = '';
                        card.style.marginRight = '';
                    });
                    
                    embla = createEmbla();
                    updateSingleSlideStyles();
                    updateButtons();
                    updateSnappedClasses();
                    
                    viewport.style.opacity = '1';
                    
                    const forceLoadLazyImages = () => {
                        if (window.lazySizes && window.lazySizes.loader && container) {
                            const lazyElements = container.querySelectorAll('[data-bg]:not(.lazy-loaded)');
                            lazyElements.forEach(el => {
                                if (!el.classList.contains('lazy')) {
                                    el.classList.add('lazy');
                                }
                                if (!el.classList.contains('lazyload')) {
                                    el.classList.add('lazyload');
                                }
                                const dataBg = el.getAttribute('data-bg');
                                if (dataBg && !el.classList.contains('lazy-loaded')) {
                                    if (window.lazySizes.loader.unveil) {
                                        window.lazySizes.loader.unveil(el);
                                    }
                                }
                            });
                            window.lazySizes.loader.checkElems();
                        }
                    };
                    
                    setTimeout(() => {
                        forceLoadLazyImages();
                    }, 100);
                    
                    setTimeout(() => {
                        forceLoadLazyImages();
                    }, 300);
                    
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            forceLoadLazyImages();
                        });
                    });
                }
            }, 50);
        }, 150);
    };
    
    let embla = createEmbla();
    updateSingleSlideStyles();
    updateButtons();
    updateSnappedClasses();
    
    const initLazyForGames = () => {
        if (window.lazySizes && window.lazySizes.loader && container) {
            const lazyElements = container.querySelectorAll('.lazy[data-bg]:not(.lazy-loaded)');
            lazyElements.forEach(el => {
                if (!el.classList.contains('lazyload')) {
                    el.classList.add('lazyload');
                }
            });
            window.lazySizes.loader.checkElems();
        }
    };
    
    setTimeout(initLazyForGames, 300);
    
    window.addEventListener('load', initLazyForGames);
    
    if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', () => {
            if (embla) {
                embla.scrollPrev();
            }
        });
        
        nextBtn.addEventListener('click', () => {
            if (embla) {
                embla.scrollNext();
            }
        });
    }
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (window.innerWidth > 1100 && embla) {
                reInitEmbla();
            }
            if (embla) {
                updateSingleSlideStyles();
                updateSnappedClasses();
            }
        }, 150);
    });
    
    categoryButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            const category = this.getAttribute('data-category');
            
            categoryButtons.forEach(b => b.classList.remove('games__category-btn--active'));
            this.classList.add('games__category-btn--active');
            
            filterAndInit(category);
        });
    });
    
    const handleBookingButtonClick = (e) => {
        if (e.target.closest('.games__card-booking-btn')) {
            e.preventDefault();
            const target = document.querySelector('#booking');
            if (target) {
                const header = document.querySelector('.header');
                const headerHeight = header ? header.offsetHeight : 0;
                const targetOffset = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                
                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth'
                });
            }
        }
    };
    
    if (container) {
        container.addEventListener('click', handleBookingButtonClick);
    }
    
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden && window.lazySizes && window.lazySizes.loader) {
            window.lazySizes.loader.checkElems();
        }
    });
    
    window.addEventListener('focus', () => {
        if (window.lazySizes && window.lazySizes.loader) {
            window.lazySizes.loader.checkElems();
        }
    });
}

export default initGames;
